module.exports = __webpack_public_path__ + "static/media/digitalid.0eda409d.png";